export function buildUrl(base: string, path: string, port?: string): string {
    return `${base}${port ? `:${port}` : ''}${path}`;
}
